const Utils = require('core-helpers/utils.js');
const ExceptionService = require('exceptions/exception-service.js');
const IntercomScript = require('third-party/script-intercom.js');
const CurrentUser = require('user/current-user-service.js');
const ProgressService = require('user/progress-service.js');

/**
 * Intercom Controller
 */
const Intercom = (function(root, doc, undefined) {

    'use strict';

    /*
     * Private vars
     */
    const APP_ID_PROD = 'xawv0n6r';
    const APP_ID_TEST = 'jl23wpxw';
    const filename = 'tracking-intercom.js';

    const getIntercomID = () => {
        return Utils.isProduction() ? APP_ID_PROD : APP_ID_TEST;
    };

    /**
     * Checks if Intercom is present on window object
     * @return {Boolean}
     */
    const isIntercomPresent = () => {
        if (!root.Intercom) {
            ExceptionService.handle('warning', {
                filename: filename,
                message: 'Intercom is not found on the window.'
            });
            return false;
        }
        return true;
    };

    const bootstrapIntercom = (user) => {

        const APP_ID = getIntercomID();
        IntercomScript.load(APP_ID);

        if (!isIntercomPresent()) {
            return false;
        }

        if (!user) {
            root.Intercom('boot', {
                app_id: APP_ID
            });
        } else {
            root.Intercom('boot', {
                app_id: APP_ID,
                name: user.name,
                email: user.email,
                created_at: user.created,
                user_id: user.uid,
                custom_country: user.country
            });
        }

    };

    const fetchUser = () => {
        return CurrentUser.get();
    };

    const init = () => {
        fetchUser().then(bootstrapIntercom).catch(bootstrapIntercom).done();
    };

    init();

})(window, document);

module.exports = Intercom;
